











































import { Component, Mixins } from 'vue-property-decorator'
import { TCWApiError } from '@/plugins/TCWBaseError'
import * as ApiPath from '@/tcw/constant/ApiPath'
import BaseComponent from '@/tcw/components/BaseComponent'
import { ApiGeneralSinglePayload, EditableResponse, LoginRequest } from '@/tcw/api/types'
import TcwFormItemText from '@/components/common/form/TcwFormItemText.vue'

@Component
export default class Login extends Mixins(BaseComponent) {
  private form: LoginRequest = {
    loginId: '',
    password: ''
  }
  private errorMessage = ''

  private async login() {
    // ログインボタンからフォーカスを外す
    ;(this.$refs.loginBtn as HTMLElement).blur()
    console.log('ログイン実行：' + this.form.loginId)
    this.isLoading = true
    try {
      await this.$tcw.session.login(this.form)

      // ログイン成功後画面遷移
      if (this.isFirstLoginFlow) {
        // 初回ログインフロー
        await this.goFirstLoginFlow()
      } else {
        await this.goFirstPage()
      }
    } catch (e) {
      // ログイン失敗
      if (e instanceof TCWApiError && e.getStatusCode() === 403) {
        this.errorMessage = 'ユーザIDかパスワードのいずれか、または両方間違っています'
      } else {
        this.throwError(e)
      }
    } finally {
      this.isLoading = false
    }
  }

  /**
   * ログインフォームでのエンターキーアクション。
   * 未入力の項目があればそちらにフォーカスを当てる。
   * 全て入力済みであればログイン処理実行。
   */
  private doLoginAction() : void {
    if (this.$refs.loginId instanceof TcwFormItemText && this.$refs.loginId.valueAsString === '') {
      this.$refs.loginId.focus();
    } else if (this.$refs.password instanceof TcwFormItemText && this.$refs.password.valueAsString === '') {
      this.$refs.password.focus();
    } else {
      this.login()
    }
  }

  /**
   * 初回ログインフロー画面遷移
   */
  private async goFirstLoginFlow(): Promise<void> {
    // メッセージ表示
    this.$router.push('/settei/project')
  }

  /**
   * ログイン後のページ遷移
   * ページが指定されていた場合はそのページへ
   * ページが指定されていない場合は初期画面へ
   * 本日付の勤怠が未登録の場合は勤怠入力画面へ
   */
  private async goFirstPage(): Promise<void> {
    // ページ指定をチェック
    const fullPath = this.$route.fullPath
    console.log(fullPath)
    if (fullPath !== '/') {
      // ページ指定されていたらそのページへ
      return
    }

    // 当日の勤怠が未入力の場合は入力画面へ
    let isMove = await this.checkMoveTimeCardPage()
    if (isMove) {
      this.goto('/timecard')
      return
    }

    // TODO 先月の勤怠が未提出の場合は勤怠提出画面へ

    // TODO 承認依頼が来ている場合は承認一覧画面へ

    // ページが指定されていない場合は勤怠一覧に移動
    this.$router.push('/kintai/list')
  }

  private async checkMoveTimeCardPage(): Promise<boolean> {
    const apiPath = ApiPath.buildPath(ApiPath.Paths.KintaiExists.get, {
      year: this.currentDate.getFullYear(),
      month: this.currentDate.getMonth() + 1,
      day: this.currentDate.getDate()
    })
    try {
      const response = await this.getWebApi().call<EditableResponse<ApiGeneralSinglePayload>>(apiPath, 'GET')
      if (!response || !response.payload.id || !response.payload.kaishi || !response.payload.shuryo) {
        return true
      } else {
        return false
      }
    } catch (e) {
      return true
    }
  }

  /**
   * ログイン画面初期処理
   */
  protected created(): void {
    this.execLoginInitProc()
  }

  private async execLoginInitProc(): Promise<void> {
    console.log('ログイン画面 初期処理')

    // アプリ更新チェック用ハッシュ値がCookieに設定されているかチェック
    if (!this.$cookies.isKey('app_hash')) {
      this.isLoading = true
      // 必ず設定されている前提とするので、未設定の場合はリロード
      console.log('ハッシュ値未設定のため、アプリリロードします')
      this.reloadApp()
    }

    // トークンがクッキーに保存されていたらセッションデータをサーバから取得する
    if (this.hasToken()) {
      console.log('トークンが残っているため、セッションを再取得します')
      this.restoreSession()
    }
  }
}
